import {Component, Input} from '@angular/core';
import {ReporteServices} from '../../services/reporte.services';


@Component({
  selector: 'estado-widget',
  templateUrl: '../../templates/widgets/estado.widget.template.html',
  styleUrls:['../../styles/reporte.dashboard.styles.scss']
})
export class EstadoWidgetComponent {

  ventas: number = 0;

  minimo: number = 0;

  meta: number = 0;

  cumplimiento:number = 0;
  friedman:number = 0 ;

  @Input()
  nombreEntidad:string = "Tienda";


  mostrar:boolean = false;

  datos:any = {};

  @Input()
  esComparativo:boolean = false;

  constructor(private rs: ReporteServices) {}

  consultar(entidad: number, idEntidad: any, fecha1: string, fecha2: string) {

    this.ventas = 0;
    this.meta = 0;
    this.minimo = 0;
    this.mostrar = false;
    this.rs.mostrarSemaforo = false;

    this.rs.devolverReporteEstado(entidad, idEntidad, fecha1, fecha2).subscribe(d => {

      if (d.data.reporteEstado) {
        let data = JSON.parse(d.data.reporteEstado);
        this.ventas = data.ventas;
        this.meta = data.meta;
        this.minimo = this.meta * .9;
        this.cumplimiento = this.ventas / this.meta * 100;

        if (this.cumplimiento <= 89.99)
          this.friedman = 0;
        else if (this.cumplimiento <= 99.99)
          this.friedman = 1;
        else if (this.cumplimiento <= 109.99)
          this.friedman = 2;
        else
          this.friedman = 3;
        this.mostrar = true;
      }

      if(d.data.reporteIndGeneral){
        this.datos = JSON.parse(d.data.reporteIndGeneral);

        this.rs.indicadores.ventas = this.ventas;
        this.rs.indicadores.meta = this.meta;
        this.rs.indicadores.minimo = this.minimo;
        this.rs.indicadores.ticketPromedio = this.datos.ticketPromedio;
        this.rs.indicadores.articuloTicket = this.datos.articuloTicket;
        this.rs.indicadores.ticketDia = this.datos.ticketDia;
        this.rs.indicadores.ventaDia = this.datos.ventaDia;

        this.rs.mostrarSemaforo = true;

      }
    });

  }

  consultandoDatos(){
    this.ventas = 0;
    this.meta = 0;
    this.minimo = 0;
    this.mostrar = false;
    this.rs.mostrarSemaforo = false;
  }

  ingresarDatos(estado:any, indGeneral:any){


    let data = JSON.parse(estado);
    this.ventas = data.ventas;
    this.meta = data.meta;
    this.minimo = this.meta * .9;
    this.cumplimiento = this.ventas / this.meta * 100;

    if (this.cumplimiento <= 89.99)
      this.friedman = 0;
    else if (this.cumplimiento <= 99.99)
      this.friedman = 1;
    else if (this.cumplimiento <= 109.99)
      this.friedman = 2;
    else
      this.friedman = 3;
    this.mostrar = true;


    this.datos = JSON.parse(indGeneral);

    this.rs.indicadores.ventas = this.ventas;
    this.rs.indicadores.meta = this.meta;
    this.rs.indicadores.minimo = this.minimo;
    this.rs.indicadores.ticketPromedio = this.datos.ticketPromedio;
    this.rs.indicadores.articuloTicket = this.datos.articuloTicket;
    this.rs.indicadores.ticketDia = this.datos.ticketDia;
    this.rs.indicadores.ventaDia = this.datos.ventaDia;

    this.rs.mostrarSemaforo = true;
  }

}
